import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#0F172A",
          fontFamily: "'DM Sans', sans-serif",
          padding: "24px",
        }}>
          <div style={{ textAlign: "center", maxWidth: "400px" }}>
            <div style={{
              width: "64px",
              height: "64px",
              backgroundColor: "rgba(249,115,22,0.1)",
              borderRadius: "16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
              fontSize: "28px",
            }}>
              ⚠️
            </div>
            <h1 style={{
              color: "#FFFFFF",
              fontSize: "20px",
              fontWeight: "700",
              marginBottom: "8px",
              fontFamily: "'Sora', sans-serif",
            }}>
              Something went wrong
            </h1>
            <p style={{
              color: "#94A3B8",
              fontSize: "14px",
              lineHeight: "1.6",
              marginBottom: "24px",
            }}>
              An unexpected error occurred. Please refresh the page. If the problem persists, contact support.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                backgroundColor: "#F97316",
                color: "#FFFFFF",
                border: "none",
                borderRadius: "12px",
                padding: "12px 28px",
                fontSize: "14px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}